import { uniqBy } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Toggle from 'react-toggle';
import { useSetDeleteMode } from '../../../queries/ats/recordings/mutations';
import { Recording } from '../../../queries/ats/recordings/types/recording';
import css from './delete-mode-toggle.module.scss';
import { getDeleteMode } from './utils';
import 'react-toggle/style.css';

interface DeleteModeToggleProps {
  recordings: Recording[];
}

export function DeleteModeToggle({ recordings }: DeleteModeToggleProps) {
  const { t } = useTranslation();

  const { mutate, isLoading } = useSetDeleteMode();

  const isChecked = useMemo(() => {
    return getDeleteMode(recordings) === 'auto';
  }, [recordings]);

  const toggle = useCallback(() => {
    const tasks = uniqBy(recordings, 'taskId');
    const singles = recordings.filter((rec) => rec.type === 'single');
    const recs = tasks.concat(singles);
    const deleteMode = isChecked ? 'manual' : 'auto';
    recs.forEach((rec) => mutate({ recording: rec, deleteMode }));
  }, [isChecked, mutate, recordings]);

  return (
    <div className={css.delete}>
      <div className={css.toggle}>
        {t('delete automatically')}
        <Toggle
          checked={isChecked}
          onChange={() => toggle()}
          icons={false}
          disabled={isLoading || recordings.length === 0}
        />
      </div>

      <p className={css.text}>
        {t('delete automatically description before tack')} "<span className="aib-icon">&</span>{' '}
        <span>" {t('delete automatically description after tack')}</span>
      </p>
    </div>
  );
}
